import type { FlightsFiltersValues } from './flightFilterTypes'
import { FlightsFiltersPriceType } from './flightFilterTypes'

export const standaloneFlightsFiltersInitialState: FlightsFiltersValues = {
  stops: [],
  airlines: [],
  cabinTypes: [],
  carriers: [],
  stopDurations: undefined,
  durations: undefined,
  priceFilterType: FlightsFiltersPriceType.ADULT,
  recommended: [],
  bags: [],
  memberPrices: [],
  stopOverCities: [],
  alliances: [],
  maxArrivalTime: undefined,
  maxDepartureTime: undefined,
  maxPrices: undefined,
  minArrivalTime: undefined,
  minDepartureTime: undefined,
  minPrices: undefined,
  sort: undefined,
}
